import * as images from "../assets/images";

// Infos

let size: any;
size = [
  {
    name: "15cm",
    category: "Size",
    carb: 1,
    fat: 1,
    protein: 1,
    kcal: 1,
    sodium: 1,
  },
  {
    name: "30cm",
    category: "Size",
    carb: 2,
    fat: 2,
    protein: 2,
    kcal: 2,
    sodium: 2,
  },
];

let bread: any;

bread = [
  {
    name: "9 Grãos",
    category: "Pão",
    img: images.noveGraos,
    img2: images.noveGraosInferior,
    carb: 40,
    fat: 0.3,
    protein: 8.5,
    kcal: 208,
    sodium: 226,
  },
  {
    name: "3 Queijos",
    category: "Pão",
    img: images.tresQueijos,
    img2: images.tresQueijosInferior,
    carb: 36,
    fat: 1.3,
    protein: 12,
    kcal: 219,
    sodium: 271,
  },
  {
    name: "Parmesão e Oregano",
    category: "Pão",
    img: images.parmesaEOregano,
    img2: images.parmesaEOreganoInferior,
    carb: 37,
    fat: 0.4,
    protein: 11,
    kcal: 205,
    sodium: 383,
  },
  {
    name: "Italiano Branco",
    category: "Pão",
    img: images.italianoBranco,
    img2: images.italianoBrancoInferior,
    carb: 36,
    fat: 0.3,
    protein: 11,
    kcal: 198,
    sodium: 214,
  },
  // {
  // name: '9 Grãos Aveia e Mel',
  // category: 'Pão',
  // img: aveiaEMel,
  // img2: aveiaEMelInferior,
  // carb:999,
  // fat:999,
  // protein:999,
  // kcal:999,
  // },
];

let flavor: any;
flavor = [
  {
    name: "Vegetariano",
    category: "Sabor",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Steak Churrasco",
    category: "Sabor",
    img: images.steak,
    carb: 6.1,
    fat: 9.6,
    protein: 9,
    kcal: 147,
    sodium: 480,
  },
  {
    name: "Frango Teriyaki",
    category: "Sabor",
    img: images.frango,
    carb: 3,
    fat: 1.5,
    protein: 13.2,
    kcal: 78,
    sodium: 258,
  },
];

let cheese: any;
cheese = [
  {
    name: "Nenhum",
    category: "Queijo",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },

  {
    name: "Suiço",
    category: "Queijo",
    img: images.swiss,
    carb: 0.8,
    fat: 3.8,
    protein: 1.4,
    kcal: 44,
    sodium: 140,
  },
  {
    name: "Cheddar",
    category: "Queijo",
    img: images.cheddar,
    carb: 0.8,
    fat: 3.8,
    protein: 1.4,
    kcal: 43,
    sodium: 171,
  },
  {
    name: "Mussarela",
    category: "Queijo",
    img: images.mozzarella,
    carb: 30,
    fat: 3,
    protein: 2.5,
    kcal: 38,
    sodium: 49,
  },
];

let extra: any;
extra = [
  {
    name: "Nenhum",
    category: "Adicional",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Bacon",
    category: "Adicional",
    img: images.bacon,
    carb: 0.6,
    fat: 5.6,
    protein: 4.8,
    kcal: 72,
    sodium: 282,
  },
  {
    name: "Peperoni",
    category: "Adicional",
    img: images.pepperoni,
    carb: 0,
    fat: 7.6,
    protein: 3.5,
    kcal: 83,
    sodium: 258,
  },
  {
    name: "Salame",
    category: "Adicional",
    img: images.salami,
    carb: 0,
    fat: 6.5,
    protein: 5,
    kcal: 78,
    sodium: 323,
  },
  {
    name: "Cheddar Cremoso",
    category: "Adicional",
    img: images.creamyCheddar,
    carb: 2.4,
    fat: 6.3,
    protein: 2.3,
    kcal: 75,
    sodium: 376,
  },
  {
    name: "Cream Cheese",
    category: "Adicional",
    img: images.creamCheese,
    carb: 1.7,
    fat: 8.8,
    protein: 1.7,
    kcal: 92,
    sodium: 121,
  },

  {
    name: "Dobro de Queijo: Suiço",
    category: "Adicional",
    img: images.swiss,
    carb: 0.8,
    fat: 3.8,
    protein: 1.4,
    kcal: 44,
    sodium: 140,
  },
  {
    name: "Dobro de Queijo: Cheddar",
    category: "Adicional",
    img: images.cheddar,
    carb: 0.8,
    fat: 3.8,
    protein: 1.4,
    kcal: 43,
    sodium: 171,
  },
  {
    name: "Dobro de Queijo: Mussarela",
    category: "Adicional",
    img: images.mozzarella,
    carb: 30,
    fat: 3,
    protein: 2.5,
    kcal: 38,
    sodium: 49,
  },
];

let saladAlface: any;
saladAlface = [
  {
    name: "Sem Alface",
    category: "Salada",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },

  {
    name: "Alface",
    category: "Salada",
    img: images.alfacePicada,
    carb: 0.2,
    fat: 0,
    protein: 0.2,
    kcal: 2.5,
    sodium: 1.9,
  },
];
let saladTomate: any;
saladTomate = [
  {
    name: "Sem Tomate",
    category: "Salada",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Tomate",
    category: "Salada",
    img: images.tomate,
    carb: 1.4,
    fat: 0.1,
    protein: 0.3,
    kcal: 6.3,
    sodium: 1.7,
  },
];
let saladPimentao: any;
saladPimentao = [
  {
    name: "Sem Pimentao",
    category: "Salada",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Pimentão",
    category: "Salada",
    img: images.pimentaoverde,
    carb: 0.3,
    fat: 0,
    protein: 0.1,
    kcal: 1.4,
    sodium: 0.2,
  },
];
let saladCebola: any;
saladCebola = [
  {
    name: "Sem Cebola",
    category: "Salada",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Cebola",
    category: "Salada",
    img: images.cebolafatiada,
    carb: 0.7,
    fat: 0,
    protein: 0.1,
    kcal: 2.8,
    sodium: 0.3,
  },
];
let saladPicles: any;
saladPicles = [
  {
    name: "Sem Picles",
    category: "Salada",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Picles",
    category: "Salada",
    img: images.picles,
    carb: 0.1,
    fat: 0,
    protein: 0,
    kcal: 0.4,
    sodium: 49,
  },
];
let saladAzeitona: any;
saladAzeitona = [
  {
    name: "Sem Azeitona",
    category: "Salada",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Azeitona",
    category: "Salada",
    img: images.azeitonas,
    carb: 0.1,
    fat: 0,
    protein: 0,
    kcal: 0.4,
    sodium: 49,
  },
];
let saladPepino: any;
saladPepino = [
  {
    name: "Sem Pepino",
    category: "Salada",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },
  {
    name: "Pepino",
    category: "Salada",
    img: images.pepino,
    carb: 0.5,
    fat: 0,
    protein: 0.1,
    kcal: 2.1,
    sodium: 0.3,
  },
];

let sauce: any;
sauce = [
  {
    name: "Nenhum",
    category: "Molho",
    img: "",
    carb: 0,
    fat: 0,
    protein: 0,
    kcal: 0,
    sodium: 0,
  },

  {
    name: "Barbecue",
    category: "Molho",
    img: images.barbecue,
    carb: 4.5,
    fat: 0.2,
    protein: 0.1,
    kcal: 20,
    sodium: 162,
  },
  {
    name: "Cebola Agridoce",
    category: "Molho",
    img: images.cebolaAgridoce,
    carb: 6.4,
    fat: 0,
    protein: 0,
    kcal: 26,
    sodium: 64,
  },
  {
    name: "Chipotle",
    category: "Molho",
    img: images.chipotle,
    carb: 1.6,
    fat: 6.5,
    protein: 0.2,
    kcal: 69,
    sodium: 135,
  },
  {
    name: "Maionese",
    category: "Molho",
    img: images.maionese,
    carb: 0.1,
    fat: 11,
    protein: 0.1,
    kcal: 102,
    sodium: 71,
  },
  {
    name: "Maionese Temperada",
    category: "Molho",
    img: images.maioneseTemperada,
    carb: 1.1,
    fat: 4.3,
    protein: 0,
    kcal: 43,
    sodium: 125,
  },
  {
    name: "Mostarde e Mel",
    category: "Molho",
    img: images.MostardaEMel,
    carb: 5,
    fat: 0.2,
    protein: 0.2,
    kcal: 20,
    sodium: 68,
  },
  {
    name: "Parmesão",
    category: "Molho",
    img: images.parmesao,
    carb: 1.3,
    fat: 5,
    protein: 0.2,
    kcal: 50,
    sodium: 153,
  },
  {
    name: "Supreme",
    category: "Molho",
    img: images.supreme,
    carb: 2.2,
    fat: 10,
    protein: 0.2,
    kcal: 237,
    sodium: 237,
  },
];

export {
  size,
  bread,
  flavor,
  cheese,
  extra,
  saladAlface,
  saladTomate,
  saladPimentao,
  saladCebola,
  saladAzeitona,
  saladPicles,
  saladPepino,
  sauce,
};
